// extracted by mini-css-extract-plugin
export default {"modal":"BroadcastMessagesModal_modal__Ta4Y2"};